import { ButtonERP } from "@finanedi.es/storybook"
import { faAdd } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FormaContactoReadingDtoProps } from "api/DTOs/FormaContactoReadingDto"
import Modal from "common/components/Modal/Modal"
import FormasContactoService from "common/services/FromasContactoService"
import {
  DEFAULT_FORMAS_CONTACTO,
  contactoUpdateSuccessAlert,
} from "features/Contactos/constants"
import { nanoid } from "nanoid"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import FormaContactoForm from "../../forms/FormaContacto"
import FormaContactoItem from "../FormaContactoItem"

const DatosContacto = ({
  empresaContactoId,
}: {
  empresaContactoId?: string
}) => {
  const { t } = useTranslation()
  const [formasContacto, setFormasContacto] = useState(DEFAULT_FORMAS_CONTACTO)
  const [openAddFormaContactoModal, setAddFormaContactoModal] = useState(false)
  const [selectedFormaContacto, setSelectedFormContacto] = useState<
    FormaContactoReadingDtoProps | null | undefined
  >(null)
  const isEditing = !!selectedFormaContacto

  const closeModal = () => {
    setSelectedFormContacto(null)
    setAddFormaContactoModal(false)
  }

  const handleFetchFormasContactoSuccess = (data = []) => {
    const newFormasContacto = data.reduce((acc, value) => {
      const { principal } = value
      const type = principal ? "principals" : "others"
      return {
        ...acc,
        [type]: [...acc[type], ...[value]],
      }
    }, DEFAULT_FORMAS_CONTACTO)
    setFormasContacto(newFormasContacto)
  }

  const fetchFormasDeContacto = () => {
    if (empresaContactoId) {
      FormasContactoService.getFormasContactoEmpresaById(
        empresaContactoId
      ).then((res) => handleFetchFormasContactoSuccess(res.data || []))
    }
  }

  const handleSubmitSuccess = () => {
    contactoUpdateSuccessAlert(t)
    fetchFormasDeContacto()
  }

  const submit = (
    data: $TSMigrationFixMe,
    markAsPrincipal: $TSMigrationFixMe
  ) => {
    const isEditMode = isEditing || markAsPrincipal
    const payload = {
      ...data,
      empresaId: empresaContactoId,
    }
    FormasContactoService[`${isEditMode ? "update" : "insert"}FormaContacto`](
      payload
    )
      .then(handleSubmitSuccess)
      .finally(closeModal)
  }

  const markFormaContactoAsPrincipal = (
    formaContacto: FormaContactoReadingDtoProps
  ) => {
    const payload = {
      ...formaContacto,
      principal: true,
    }
    submit(payload, true)
  }

  const eliminarFormaContacto = (id: string) => {
    FormasContactoService.deleteFormaContacto(id).then(() =>
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      handleSubmitSuccess("eliminado")
    )
  }

  useEffect(() => {
    fetchFormasDeContacto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaContactoId])

  const openModal = (formaContacto?: FormaContactoReadingDtoProps) => {
    setSelectedFormContacto(formaContacto)
    setAddFormaContactoModal(true)
  }

  return (
    <div className='tw-mb-2 tw-flex tw-flex-col tw-items-start '>
      <div className='tw-mb-2 tw-text-sm tw-font-medium'>
        {t("contactos.editar.labelDataContact")}
      </div>
      <div className='tw-flex tw-mb-2 tw-flex-col tw-w-full tw-h-fit tw-gap-2'>
        {formasContacto.principals.map((formaContacto) => (
          <FormaContactoItem
            key={nanoid()}
            formaContacto={formaContacto}
            edit={openModal}
            markAsPrincipal={markFormaContactoAsPrincipal}
            remove={eliminarFormaContacto}
          />
        ))}
      </div>

      {formasContacto.others?.length > 0 && (
        <div className='tw-mb-2 tw-text-sm tw-font-medium'>
          {t("contactos.editar.labelOtherFormContact")}
        </div>
      )}

      <div className='tw-flex tw-flex-col tw-w-full tw-h-fit tw-gap-2 tw-mb-2'>
        {formasContacto.others?.map((formaContacto) => (
          <FormaContactoItem
            key={nanoid()}
            formaContacto={formaContacto}
            edit={openModal}
            markAsPrincipal={markFormaContactoAsPrincipal}
            remove={eliminarFormaContacto}
          />
        ))}
      </div>

      <div className='tw-w-full tw-h-fit tw-border tw-border-dashed tw-rounded-md '>
        <ButtonERP
          customize={{
            size: "md",
            type: "none",
          }}
          icon={<FontAwesomeIcon icon={faAdd} />}
          label={`${t("contactos.editar.addFormContact")}`}
          onClick={() => openModal()}
          className='!tw-w-full'
        />
      </div>
      <Modal
        header={
          isEditing
            ? `${t("contactos.editar.modal.headerEdit")} ${t(
                "contactos.editar.modal.restHeader"
              )}`
            : `${t("contactos.editar.modal.headerNew")} ${t(
                "contactos.editar.modal.restHeader"
              )}`
        }
        draggable
        maskClassName='!tw-z-20'
        visible={openAddFormaContactoModal}
        closable={false}
        size='small'
      >
        <FormaContactoForm
          // @ts-expect-error TS(2322): Type '{ isEditing: boolean; data: null; onHide: ()...
          isEditing={isEditing}
          data={selectedFormaContacto}
          onHide={closeModal}
          updateData={submit}
          t={t}
        />
      </Modal>
    </div>
  )
}

export default DatosContacto
